module.exports = __webpack_public_path__ + "static/IndexVid-5ef2a61672175b435dc22afa7452d981.webp";